import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function ClassesPage() {
  return <InstituteCrudPage config={entityConfigs['classes']} />;
}
